export default __webpack_public_path__ + "static/media/Objective-C.f719fb0d.png";